export default "__VITE_ASSET__f7a4ec9e__"